import { render, staticRenderFns } from "./ServicoRemocaoComponente.vue?vue&type=template&id=66786ea0"
import script from "./ServicoRemocaoComponente.vue?vue&type=script&lang=js"
export * from "./ServicoRemocaoComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports